import { useMutation, useQueryClient } from "@tanstack/react-query";

import { errorHandler } from "#app/monitoring/errorHandler";
import { showErrorToast } from "#app/notifications";
import { quoteRequestLineQuery } from "#modules/quoteRequestLines/infra/quoteRequestLine.query";

import { updateCluster, UpdateClusterResponse } from "./updateCluster.api";

type Options = {
  onSuccess?: (quoteRequesLine: UpdateClusterResponse | null) => void;
};

export const useUpdateCluster = (options?: Options) => {
  const queryClient = useQueryClient();

  const { mutate, ...rest } = useMutation({
    mutationFn: updateCluster,
    onSuccess: async (quoteRequesLine) => {
      void queryClient.invalidateQueries(quoteRequestLineQuery({ id: quoteRequesLine?.id ?? "" }));

      options?.onSuccess?.(quoteRequesLine);
    },
    onError: (err) => {
      showErrorToast({
        title: "Une erreur est survenue lors de création du cluster",
      });
      errorHandler(err);
    },
  });

  return { updateCluster: mutate, ...rest };
};
